// src/pages/ForgotPassword.jsx
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../utilities/api';

function ForgotPassword() {
  const [loginName, setLoginName] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    setLoading(true);
    try {
      const trimmedLoginName = loginName.trim();
      const result = await api.forgotPassword({
        user_name: trimmedLoginName,
        identifier: trimmedLoginName,
        email: trimmedLoginName,
        origin: window.location.origin,
      });
      if (result.success) {
        setMessage('Password reset instructions have been sent to your verified recovery channel.');
        setTimeout(() => navigate('/login'), 3000);
      } else {
        setError(result.error || result.errorMsg || 'Failed to send reset link. Please try again.');
      }
    } catch {
      setError('An error occurred. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="bg-highlight min-h-[calc(100vh-4rem)] w-full px-4 py-12 sm:px-6">
      <section className="w-full max-w-md mx-auto rounded-lg bg-white p-6 shadow-xl sm:p-8">
        <h2 className="text-2xl font-bold text-primary mb-6">Reset Your Password</h2>
        <p className="mb-4 text-primary-light">
          Enter your login name and we'll send a reset link to your verified recovery channel.
        </p>
        <form onSubmit={handleSubmit} className="space-y-4">
          <label htmlFor="forgot-user-name" className="block text-sm font-medium text-neutral-dark">
            Username (email or mobile phone)
          </label>
          <input
            id="forgot-user-name"
            name="user_name"
            type="text"
            autoComplete="username"
            placeholder="Email address or mobile phone"
            value={loginName}
            onChange={(e) => setLoginName(e.target.value)}
            className="w-full p-2 border border-neutral rounded focus:outline-none focus:ring-2 focus:ring-primary"
            required
          />
          {message && <p className="text-green-500 text-sm">{message}</p>}
          {error && <p className="text-red-500 text-sm">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-button text-white p-2 rounded hover:bg-button-light transition duration-200 disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>
        <div className="mt-4 text-center">
          <button type="button" 
            onClick={() => navigate('/login')} 
            className="text-primary-light hover:underline ml-auto mr-0">
            Return to login
          </button>          
        </div>
      </section>
    </main>
  );
}

export default ForgotPassword;
